import SchoolCard from './SchoolCard.component';

export default SchoolCard;
